const AVERAGE_WORDS_PER_MINUTE = 200;

export const estimateReadingTime = (text: string): number => {
  // Remove extra whitespace and split on word boundaries
  const words = text.trim().split(/\s+/).filter(Boolean);
  const wordCount = words.length;
  return Math.max(1, Math.ceil(wordCount / AVERAGE_WORDS_PER_MINUTE));
};
